<template>
    <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-container class="pa-0">
                    <v-row justify="space-between" dense align="center">
                        <v-col cols="auto">
                            <v-toolbar-title>
                                {{ widget.body.title }}
                            </v-toolbar-title>
                        </v-col>

                        <v-col v-if="hasModulePermission" cols="auto">
                            <v-menu bottom right>
                                <template #activator="{on}">
                                    <v-btn
                                        small
                                        icon
                                        data-sentry-label="Przejdź do modułu"
                                        v-on="on"
                                    >
                                        <v-icon>
                                            mdi-dots-vertical
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click="redirect">
                                        <v-list-item-title>Przejdź do modułu</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-toolbar>
            <v-divider />
            <v-card-text class="text-center">
                <div class="text-h4">
                    {{ widget.body.count }}
                </div>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import router from '@/router'
import filters from '@/mixins/dataTableFilters'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'QualitativeNotes',
    mixins: [
        filters,
    ],
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    computed: {
        hasModulePermission() {
            return this.permissions.find(permission => permission.name === this.widget.redirectPermission)
        },
        savedFilters() {
            return this.$store.state.complaints.qualitativeNotes.filters
        },
        userId() {
            return this.$store.state.user.userId
        },
    },
    methods: {
        redirect() {
            if (this.widget.codeName === 'myQualitativeNotes') {
                this.filters.responsiblePerson_id = this.userId
                this.$store.dispatch('complaints/setQualitativeNotesFilters', this.filters)
            }

            router.push({ name: this.widget.redirectDestination})
                .catch(error => {
                    errorHandler(error)
                })
        }
    }
}
</script>
